module.exports = __webpack_public_path__ + "static/img/chakanjietu2.8d1babd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/chakanjietu2.png
// module id = sGA7
// module chunks = 24